import Axios from 'axios';
import { toast } from 'react-toastify';

const API_URL = process.env.REACT_APP_API_URL;

export const handleAddStudent = async (formData, setFormData) => {
    try {
        const response = await Axios.post(`${API_URL}/students/addStudent`, formData, {
            headers: { Authorization: localStorage.getItem('token') }
        });

        if (response.data.status === 'success') {
            toast.success('Student Registered Successfully!');
            setFormData({
                first_name: '', last_name: '', enrollment_number: '', school_id: '',
                lab_id: '', father_name: '', dob: '', email: '', gender: '',
                social_group: '', mobile_number: '', whatsapp_number: '',
                country: '', state: '', district: '', city_village: '',
                org_type: '', school_type: '', student_class: '',
                course_opted: '', how_to_know: ''
            });
        } else {
            toast.error(response.data.message || 'Registration failed');
        }
    } catch (error) {
        console.error('Error adding student:', error);
        toast.error('Something went wrong!');
    }
};

export const fetchStudents = async (setStudents) => {
    try {
        const response = await Axios.get(`${API_URL}/students/fetchStudents`, {
            headers: { Authorization: localStorage.getItem('token') }
        });
        if (response.data.status === 'success') {
            setStudents(response.data.data);
        }
    } catch (error) {
        console.error('Error fetching students:', error);
    }
};

export const handleAddAssessment = async (formData, setFormData) => {
    try {
        const response = await Axios.post(`${API_URL}/students/addAssessment`, formData, {
            headers: { Authorization: localStorage.getItem('token') }
        });

        if (response.data.status === 'success') {
            toast.success('Assessment added successfully!');
            setFormData({
                student_id: '',
                assessment_date: '',
                lab_id: '',
                pre_max_marks: '', pre_obtained_marks: '',
                mid_max_marks: '', mid_obtained_marks: '',
                post_max_marks: '', post_obtained_marks: '',
                remarks: ''
            });
        } else {
            toast.error(response.data.message || 'Failed to add assessment');
        }
    } catch (error) {
        console.error('Error adding assessment:', error);
        const errorMsg = error.response?.data?.message || 'Something went wrong!';
        toast.error(`Error: ${errorMsg}`);
    }
};

export const fetchAssessments = async (setAssessments) => {
    try {
        const response = await Axios.get(`${API_URL}/students/fetchAssessments`, {
            headers: { Authorization: localStorage.getItem('token') }
        });
        if (response.data.status === 'success') {
            setAssessments(response.data.data);
        }
    } catch (error) {
        console.error('Error fetching assessments:', error);
    }
};

export const fetchStudentDashboardStats = async (labId, setStats) => {
    try {
        let url = `${API_URL}/students/dashboardStats`;
        if (labId) url += `?lab_id=${labId}`;
        const res = await Axios.get(url, {
            headers: { Authorization: localStorage.getItem('token') }
        });
        if (res.data.status === 'success') {
            setStats(res.data.data);
        }
    } catch (err) {
        console.error(err);
    }
};
